// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"488":"5762e9c9","701":"c2a24515"}[chunkId] + ".chunk.js");